import { PropsWithChildren } from 'react'

import { WebOfficeEditor } from './Editor'
import { WebOfficeEditorProps } from './Editor/interface'
import { WebOfficeStoreProvider } from './Store'

export const WebOffice = ({
  children,
  /* -------------------------------------------------------------------------- */
  /*                                Editor Props                                */
  /* -------------------------------------------------------------------------- */
  ...editorProps
}: PropsWithChildren<WebOfficeEditorProps>) => {
  return (
    <WebOfficeStoreProvider>
      <WebOfficeEditor {...editorProps} />
      {children}
    </WebOfficeStoreProvider>
  )
}
